import type { AxiosProgressEvent } from "axios";

/** Caller-supplied progress callback. Receives 0-100, or null for
 *  the rare case where the browser can't report total bytes. */
export type UploadProgressFn = (percent: number | null) => void;

/**
 * Wraps an UploadProgressFn so it can be passed directly to axios's
 * `onUploadProgress`. Returns undefined when the caller didn't provide
 * a callback, so request configs stay clean.
 */
export function makeAxiosProgress(cb: UploadProgressFn | undefined) {
  if (!cb) return undefined;
  return (e: AxiosProgressEvent) => {
    if (e.total) {
      cb(Math.min(100, Math.round((e.loaded / e.total) * 100)));
    } else {
      cb(null);     // length unknown — caller can render an indeterminate state
    }
  };
}
